/**
 * @generated SignedSource<<621096a96b783e08c71cb4578e4d62e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubmitButton_Fragment$data = {
  readonly flow: {
    readonly name: string;
  } | null | undefined;
  readonly flowId: UUID;
  readonly " $fragmentType": "SubmitButton_Fragment";
};
export type SubmitButton_Fragment$key = {
  readonly " $data"?: SubmitButton_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubmitButton_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubmitButton_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Module",
  "abstractKey": null
};

(node as any).hash = "ada6bea6b82e8cb2ca0069b445e43160";

export default node;
